/*jshint esversion: 6 */
export default {
	TestTrick: function () {
		console.log('Ta-daaaa');
	},

	HandleAxiosErrors(code)
	{
		switch (code) {
			case 500:
				this.ShowServerErrorAlert();
				break;

			default:
				break;
		}
	},

	ShowServerErrorAlert() {
		Swal.fire({
			title: "Error inesperado",
			text: "Lo sentimos, ha ocurrido un error inesperado, si persiste por favor contacta con nosotros en info@lexa-go.com",
			allowOutsideClick: false,
			icon: "info",
			showCancelButton: false,
			confirmButtonText: "Aceptar",
			buttonsStyling: false,
			customClass: {
				confirmButton: 'submitButton swalButton',
			}
		}).then((result) => {
			location.reload();
		});
	},
};